import { AUTOPILOT_BASE_PATH } from 'app/pages/AutopilotPage/utils/autopilotPaths';
import type { PageConfig } from '../types';

export const pipelinePageConfig: PageConfig = {
  id: 'pipeline',
  tabLabel: 'Pipeline',
  sections: [
    {
      id: 'hero',
      titleFromMetric: true,
      layout: 'grid-1',
      items: [{ kind: 'metric', id: 'prospects_under_nurturing', span: 'full' }],
    },
    {
      id: 'pipeline-stats',
      layout: 'grid-4',
      items: [
        { kind: 'metric', id: 'cold_leads_revived', renderer: 'statCard' },
        { kind: 'metric', id: 'sales_influenced', renderer: 'statCard' },
        { kind: 'metric', id: 'engagement_rate', renderer: 'statCard' },
        { kind: 'metric', id: 'unsubscribe_rate', renderer: 'statCard' },
      ],
    },
    {
      id: 'cohort-state',
      overline: 'COHORT STATE',
      action: {
        label: 'View full list',
        navigation: { type: 'route', path: AUTOPILOT_BASE_PATH },
      },
      layout: 'grid-4',
      items: [
        { kind: 'metric', id: 'customers_sit_right_now', span: 'full' },
        { kind: 'metric', id: 'cohort_recent_additions_count' },
        { kind: 'metric', id: 'cohort_period_removals_count' },
        { kind: 'metric', id: 'cohort_engaged_count' },
        { kind: 'metric', id: 'cohort_long_term_nurturing_count' },
      ],
    },
    
    {
      id: 'new-this-period',
      overline: 'NEW THIS PERIOD',
      titleFromMetric: true,
      layout: 'grid-1',
      items: [{ kind: 'metric', id: 'new_enrollments_by_vehicle_model', span: 'full' }],
    },
    {
      id: 'buyer-segments',
      overline: 'BUYER SEGMENTS',
      titleFromMetric: true,
      actions: [
        { label: 'Export ↓', navigation: { type: 'exportCsv' } },
        { label: 'See full breakdown', navigation: { type: 'L2' } },
      ],
      layout: 'grid-1',
      items: [{ kind: 'metric', id: 'buyer_segment_count', span: 'full' }],
    },
    {
      id: 'channels',
      overline: 'CHANNELS',
      title: 'Which channels did the cold leads come back from',
      layout: 'grid-3',
      items: [
        { kind: 'metric', id: 'attributed_internet_conversion_rate' },
        { kind: 'metric', id: 'walk_in_conversion_rate' },
        { kind: 'metric', id: 'phone_up_conversion_rate' },
      ],
    },
  ],
};
